"use client";
import {useLocale} from "next-intl";
import {Link} from "@/i18n/navigation";
import styles from "./finder.module.css";
import {trackGizmo} from "@/lib/analytics";
export default function RelatedFinders({source, compact=false}: {source:string;compact?:boolean}) {
  const locale=useLocale();
  if(locale!=="en") return null;
  const links=[
    {href:"/virtual-makeover",title:"Try the complete Look Studio",text:"Hair, lipstick and blush together on one photo. Compare complete looks."},
    {href:"/what-color-blush-should-i-wear",title:"Find my blush colors",text:"See rose, peach and berry on your photo. Adjust the flush and compare."},
    {href:"/what-color-lipstick-should-i-wear",title:"Find my lipstick shades",text:"Try nudes, reds and berries on your own lips. Save your favorites."},
    {href:"/best-hair-colors-for-skin-tone",title:"Find my hair colors",text:"Preview colors on your photo, with three free try-ons."},
  ];
  return <section className={styles.section} aria-label="Find your makeup and hair colors" style={{marginTop:compact?24:40,marginBottom:32}}>
    <h2>{compact ? "Put your palette to use" : "Find the shades you are shopping for"}</h2>
    {!compact&&<p>See colors on a photo, compare your favorites, and find a look you want to try.</p>}
    <div className={compact?styles.related:styles.guideGrid}>{links.filter(l=>l.href!==source).map(l=>compact?<Link key={l.href} href={l.href} onClick={()=>trackGizmo("finder_hub_click",{source,destination:l.href})}>{l.title} →</Link>:<article key={l.href} className={styles.guideCard}><h3><Link href={l.href} onClick={()=>trackGizmo("finder_hub_click",{source,destination:l.href})}>{l.title} →</Link></h3><p>{l.text}</p></article>)}</div>
  </section>;
}
